module.exports = "/images/applepay.svg?c68c34a5703e0ffccec7ed94f66796c2";